import { Component, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizeRouterService } from '@app/i18n';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule],
})
export class SearchComponent implements OnInit {
    private router = inject(Router);
    private activatedRoute = inject(ActivatedRoute);
    private localizeRouterService = inject(LocalizeRouterService);
    private formBuilder = inject(NonNullableFormBuilder);

    private subscriptions$ = new Subscription();

    form = this.formBuilder.group({
        search: [''],
    });

    ngOnInit(): void {
        this.subscriptions$.add(
            this.activatedRoute.queryParams
                .pipe(
                    tap((data) => {
                        if (data['q']) {
                            if (data['q'] !== this.form.controls['search'].value) {
                                this.form.get('search')?.patchValue(data['q']);
                            }
                        } else {
                            this.form.controls['search'].patchValue('');
                        }
                    }),
                )
                .subscribe(),
        );
    }

    onSubmit(): void {
        const search = this.form.controls['search'].value;
        const q = this.activatedRoute.snapshot.queryParams['q'] ? this.activatedRoute.snapshot.queryParams['q'] : '';
        const url = this.localizeRouterService.translateRoute(['/products', 'page', '1']);

        if (search) {
            void this.router.navigate(url, {
                queryParams: { q: search },
                queryParamsHandling: 'merge',
            });
        } else if (search !== q) {
            void this.router.navigate(url);
        }
    }
}
